export const APP = {
  CONFIG: {
    USER_INACTIVITY: 1800000,
  },
}
